"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Welcome = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRedux = require("react-redux");

var _styles = _interopRequireDefault(require("../styles"));

var _Style = _interopRequireDefault(require("./Style"));

var _utilities = require("../utilities");

var _constants = require("../constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

var Welcome = function Welcome(_ref) {
  var env = _ref.env,
      market = _ref.market;
  return market === _constants.MARKET_EN_US ? _react.default.createElement(_react.Fragment, null, _react.default.createElement("div", {
    className: "help--welcome-container"
  }, _react.default.createElement("img", {
    className: "help--welcome-image",
    src: "".concat((0, _utilities.getCdnPath)(env), "/v1/img/banner.png"),
    alt: ""
  }), _react.default.createElement("div", {
    className: "help--welcome-title"
  }, 'We\'re here to help every step of the way.')), _react.default.createElement(_Style.default, {
    css: "\n      .help--welcome-container {\n        background-color: ".concat(_styles.default.colors.grayLight, ";\n        text-align: center;\n        position: relative;\n      }\n\n      .help--welcome-image {\n        width: 100%;\n        height: 100%;\n      }\n\n      .help--welcome-title {\n        position: absolute;\n        top: 50%;\n        left: 59%;\n        transform: translate(-50%, -50%);\n        width: 75%;\n        font-family: ").concat(_styles.default.fonts.gdsage, ";\n        font-size: 1.65em;\n        font-weight: 800;\n        line-height: 1.25;\n      }\n    ")
  })) : null;
};

exports.Welcome = Welcome;
Welcome.propTypes = {
  env: _propTypes.default.string.isRequired,
  market: _propTypes.default.string.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    env: state.app.env,
    market: state.app.market
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps)(Welcome);

exports.default = _default;